import { normalizeLocaleCode } from "./normalizeLocaleCode";

export const stripLocalePrefix = (
  pathname: string,
  localeFromParams?: string | null
): string => {
  const normalizedPath = pathname.startsWith("/") ? pathname : `/${pathname}`;

  if (!localeFromParams || normalizeLocaleCode(localeFromParams) === "") {
    return normalizedPath;
  }

  const normalizedLocaleFromParams = normalizeLocaleCode(localeFromParams);
  const localePrefix = `/${normalizedLocaleFromParams}`;

  if (normalizedPath === localePrefix) {
    return "/";
  }

  if (normalizedPath.startsWith(`${localePrefix}/`)) {
    const pathnameWithoutLocale = normalizedPath.slice(localePrefix.length);

    return pathnameWithoutLocale.startsWith("/")
      ? pathnameWithoutLocale
      : `/${pathnameWithoutLocale}`;
  }

  return normalizedPath;
};

export const buildPathWithLocale = (
  urlLocaleLower: string,
  restPath: string
): string => {
  const normalizedLocale = normalizeLocaleCode(urlLocaleLower);
  const localeSegment = normalizedLocale.split("/").filter(Boolean)[0] ?? "";
  const normalizedRestPath = (restPath || "/").startsWith("/")
    ? restPath || "/"
    : `/${restPath}`;

  if (!localeSegment) {
    return normalizedRestPath;
  }

  if (normalizedRestPath === "/") {
    return `/${localeSegment}`;
  }

  return `/${localeSegment}${normalizedRestPath}`;
};
